import React from 'react';
import * as reduxSelectors from '../store/application.reducers';
import {connect} from 'react-redux';
import translate from '../translations/translations.wrapper.jsx';
import { LOADING_STATUS } from "utils/constants";
import {
    activateRule,
    activateReadonlyRule,
    deactivateReadonlyRule,
    addNewRule, clearWorkflowsHistory,
    getWorkflows,
    getWorkflowsHistory
} from './workflows.action';
import "./workflows.scss";
import {Rules} from "./Rules.component";
import * as _ from "lodash";
import {snowplowTrackEvent} from 'utils/snowplow';
import WorkflowHistoryPopUp from "../popup/WorkflowHistoryPopUp.component";
import ConfigurationWrapper from "components/configuration/ConfigurationWrapper.component.jsx";
import { Button, ButtonType } from "components/common/Button.component";


export class Workflows extends ConfigurationWrapper {

    constructor(props) {
        super(props);
        this.state = {
            currentContextId: props.currentContextId,
            showWorkflowHistory: false,
            showDocTypeFilters: true,
            selectedRuleId: null
        };
        this.openWorkflowsHistory = this.openWorkflowsHistory.bind(this);
        this.userInput = React.createRef();
    }

    openWorkflowsHistory() {
        snowplowTrackEvent({
            category: "audit trail",
            action: "open_workflow_history",
            label: "global workflows history",
            value: ""
        }, this.props.userConfiguration);

        this.props.getWorkflowsHistory(this.props.currentContextId);

        this.setState({
            showWorkflowHistory: true,
            showDocTypeFilters: true,
            selectedRuleId: null
        });

    }

    componentDidMount() {
        this.props.getWorkflows(this.props.currentContextId);
    }

    componentDidUpdate(props) {
        if (props.currentContextId !== this.props.currentContextId) {
            this.setState({
                currentContextId: this.props.currentContextId
            }, () => {
                this.props.getWorkflows(this.props.currentContextId);
            });
        }
    }

    buildContent() {
        let workflowHeaders = Object.keys(this.props.workflows).map((key, index) => {
            return <Rules rules={this.props.workflows[key]}
                          key={index}
                          index={index}
                          showActions={this.props.userData.userRoles.systemAdministrator}
                          docType={key}
                          addRule={this.props.addNewRule}
                          activateRule={this.props.activateRule}
                          activateReadonlyRule={this.props.activateReadonlyRule}
                          deactivateReadonlyRule={this.props.deactivateReadonlyRule}
                          translate={this.props.translate}
                          lastCreatedWorkflow={this.props.lastCreatedWorkflow}/>
        });

        let workflowHeadersNew = this.props.docTypes ? this.props.docTypes.map((docType, index) => {
            return <Rules rules={[]}
                          key={index}
                          index={index}
                          showActions={this.props.userData.userRoles.systemAdministrator}
                          docType={docType}
                          addRule={this.props.addNewRule}
                          activateRule={this.props.activateRule}
                          activateReadonlyRule={this.props.activateReadonlyRule}
                          deactivateReadonlyRule={this.props.deactivateReadonlyRule}
                          lastCreatedWorkflow={this.props.lastCreatedWorkflow}
                          translate={this.props.translate}/>
        }) : [];

        switch (this.props.loadingStatus) {
            case LOADING_STATUS.LOADING:
                return (<div className="col-md-12">
                    <span className="spinner spinner-default-blue loading"/>
                </div>);
            case LOADING_STATUS.DONE:
                return (
                    <main className="page w-100 mt-48 overflow-y-auto d-flex justify-content-center align-items-start">
                        <div className="py-16 mb-48 w-50 settings-page__container">
                            {this.state.showWorkflowHistory &&
                                <WorkflowHistoryPopUp
                                    closeCallback={() => {
                                        this.setState({showWorkflowHistory: false});
                                        this.props.clearWorkflowsHistory();
                                    }}
                                    docTypes={this.state.showDocTypeFilters ? this.props.docTypes : null}
                                    ruleId={this.state.selectedRuleId}
                                    translate={this.props.translate}/>
                            }
                            <div className="d-flex justify-content-between align-items-center pb-16">
                                <h2 className="mb-0 px-16">{this.props.translate("workflows.header")}</h2>
                                <Button type={ButtonType.SECONDARY}
                                        onClick={this.openWorkflowsHistory}
                                        text={this.props.translate("workflows.workflowHistoryBtn")}
                                />
                            </div>

                            <div>
                                <ul className="workflow-list list-unstyled" ref="workflowList">
                                    {_.isEmpty(this.props.workflows) ?
                                        workflowHeadersNew : workflowHeaders
                                    }
                                </ul>
                            </div>
                        </div>
                    </main>
                )

            default:
                return (<div/>);
        }
    }
}

const withTranslations = translate(Workflows);
const mapStateToProps = function (store) {
    return {
        currentContextId: reduxSelectors.getUsersCurrentContextId(store),
        userData: reduxSelectors.getUsersData(store),
        loadingStatus: reduxSelectors.getWorkflowsLoadingStatus(store),
        workflows: reduxSelectors.getWorkflowsForRender(store),
        docTypes: reduxSelectors.getWorkflowsDocTypes(store),
        userConfiguration: reduxSelectors.getUsersData(store),
        lastCreatedWorkflow: reduxSelectors.getLastCreatedWorkflow(store),
    };
};

const connected = connect(mapStateToProps, {
    activateRule,
    activateReadonlyRule,
    deactivateReadonlyRule,
    addNewRule,
    getWorkflows,
    getWorkflowsHistory,
    clearWorkflowsHistory
})(withTranslations);

export default connected;